import script from "./OrderLtvView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderLtvView.vue?vue&type=script&setup=true&lang=js"

import "./OrderLtvView.vue?vue&type=style&index=0&id=c5944764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5944764"]])

export default __exports__